import { render } from "./PatientAll.vue?vue&type=template&id=23258daa&scoped=true"
import script from "./PatientAll.vue?vue&type=script&lang=js"
export * from "./PatientAll.vue?vue&type=script&lang=js"

import "./PatientAll.vue?vue&type=style&index=0&id=23258daa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23258daa"]])

export default __exports__